import prodUrls from './production';
import stagingUrls from './staging';

var Config =
/** @class */
function () {
  function Config() {}

  Config.setEndpointsByEnv = function (isProduction) {
    if (isProduction) {
      this.urls = prodUrls;
    }
  };

  Config.urls = stagingUrls;
  return Config;
}();

export default Config;